import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles((theme) => ({
  prefixInput: {
    "& .MuiInputBase-root": {
      paddingTop: 0,
      paddingBottom: 0,
      // Arrow is hidden, so reclaim the space v5 reserves on the right for the
      // end-adornment (~39px) — otherwise long prefixes like "+380" clip.
      paddingRight: "12px !important" as any,
    },
    // v4 stripped InputProps so the prefix never showed a dropdown arrow.
    // Hide it for both variants (frees width for long prefixes like "+1 234",
    // and keeps the social icon clean). !important beats MUI's own
    // ".MuiAutocomplete-root .MuiAutocomplete-endAdornment" rule (specificity tie).
    "& .MuiAutocomplete-endAdornment": {
      display: "none !important" as any,
    },
  },
  optionRoot: {
    display: "flex",
  },
  optionIcon: {
    color: theme.palette.grey[700],
    "& svg": {
      fontSize: 20,
    },
  },
  optionValue: {},
  optionDescription: {
    flex: "1",
  },
}));
